import VillagePage from '@/components/VillagePage';

const RivedouxPlage = () => {
  return (
    <VillagePage
      villageName="Rivedoux-Plage"
      description="Premier village de l'Île de Ré après le pont, Rivedoux-Plage vous accueille avec ses plages familiales et son ambiance conviviale."
      attractions={[
        "Plage de la Côte Sauvage",
        "Port de plaisance",
        "Marché local",
        "Église Saint-Martin",
        "Pistes cyclables vers Sainte-Marie"
      ]}
      bikeRoutes={[
        "Circuit des plages (8 km)",
        "Vers Sainte-Marie-de-Ré (5 km)",
        "Tour du village (3 km)",
        "Vers La Flotte (12 km)"
      ]}
      practicalInfo={{
        beaches: ["Plage de Rivedoux", "Plage de la Côte Sauvage"],
        restaurants: ["Restaurants du port", "Crêperies", "Bars de plage"],
        markets: ["Marché d'été (juillet-août)"]
      }}
    />
  );
};

export default RivedouxPlage;